import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { TENANT_FEATURES } from '../../../services/tenant-feature.service';
import { resolveTenantMailRecipient } from '../../../../shared/helpers/tenant-mail-recipient.func';

@Component({
	selector: 'lvr-sidebar-help-menu',
	imports: [MatButtonModule, MatIconModule, MatMenuModule, RouterModule, TranslocoPipe],
	templateUrl: './sidebar-help-menu.html',
	styleUrl: '.././sidebar.scss',
})
export class SidebarHelpMenu {
	private readonly tenantFeatures = inject(TENANT_FEATURES);
	private readonly bugReportSubject = 'Fehlerbericht KlifdWeb';

	public requestBugReport() {
		const body = [
			'Hallo,',
			'',
			'ich möchte einen Fehler melden.',
			'Auftragsnummer:',
			'Kurzbeschreibung des Problems:',
			'Was habe ich gemacht:',
			'Was wird mir angezeigt:',
			'Was sollte mir angezeigt werden:',
			'Datum & Uhrzeit:',
			'Screenshot (optional)',
			'',
		].join('\n');

		const recipient = resolveTenantMailRecipient(this.tenantFeatures.tenant());
		this.openMailto(this.buildMailto(recipient, this.bugReportSubject, body));
	}

	private buildMailto(recipient: string, subject: string, body: string): string {
		return `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
	}

	private openMailto(href: string): void {
		window.location.href = href;
	}
}
